import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router";

import urls from "@/constants/Urls";
import { setSystemSettingsPage } from "@/store/reducers/app";
import { clearAuthData } from "@/store/reducers/root";
import { setDialDrawer } from "@/store/reducers/ui";
import { getVersion } from "@/utils/utility";
import {
  viArrowRightFromBracket,
  viCirclePerson,
  viCircleQuestion,
  viCompass,
  viGear,
  viGift,
  viPhone,
} from "@sippy-platform/valkyrie";

import { Divider, List, Popover } from "@mui/material";
import PropTypes from "prop-types";

import NavigationItem from "./settings/NavigationItem";

function ProfileMenu({ setProfileMenu, ...props }) {
  const dispatch = useDispatch();

  const hasPbx = useSelector((state) => state.domain.pbx.context);
  const dialDrawer = useSelector((state) => state.ui.dialDrawer);

  const helpUrl = useSelector((state) => state.ui.helpUrl);

  return (
    <Popover
      open={!!props.profileMenu}
      onClose={() => setProfileMenu(false)}
      anchorEl={props.profileMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          id: "profileMenu",
          elevation: 1,
          sx: {
            border: "1px solid",
            borderColor: "divider",
            minWidth: 200,
            mt: 0.5,
          },
        },
      }}
    >
      <List
        sx={{
          display: "flex",
          p: 1,
          ".MuiListItem-root": {
            minHeight: 40,
          },
          ".MuiListItemButton-root": {
            width: 1,
            minHeight: 40,
            py: 0,
            pr: 1.5,
            pl: 1,
          },
          ".MuiListItemText-primary": {
            fontWeight: "600",
          },
          ".MuiDivider-root": {
            m: 0.5,
          },
        }}
      >
        {hasPbx && (
          <>
            <NavigationItem
              title="Backstage"
              icon={viCompass}
              id="menu-backstage"
              component={NavLink}
              to="/backstage/home"
            />
            <Divider />
          </>
        )}
        <NavigationItem
          title="Dial"
          icon={viPhone}
          id="menu-phone"
          onClick={() => {
            dispatch(setDialDrawer(!dialDrawer));
            setProfileMenu(false);
          }}
          selected={dialDrawer}
        />
        <Divider />
        <NavigationItem
          title="Settings"
          icon={viGear}
          id="menu-settings"
          onClick={() => {
            dispatch(setSystemSettingsPage("backstage"));
            setProfileMenu(false);
          }}
        />
        <NavigationItem
          title="Profile"
          icon={viCirclePerson}
          id="menu-profile"
          onClick={() => {
            dispatch(setSystemSettingsPage("profile"));
            setProfileMenu(false);
          }}
        />
        <Divider />
        <NavigationItem
          title="Help"
          icon={viCircleQuestion}
          id="menu-help"
          onClick={() => {
            window.open(`${urls.docs}${helpUrl}`, "_blank");
            setProfileMenu(false);
          }}
        />
        <NavigationItem
          title={`New in Sippy ${getVersion("main")}`}
          icon={viGift}
          id="menu-about"
          onClick={() => {
            dispatch(setSystemSettingsPage("about"));
            setProfileMenu(false);
          }}
        />
        <Divider />
        <NavigationItem
          title="Sign out"
          color="danger"
          icon={viArrowRightFromBracket}
          id="signOutProfileMenuItem"
          onClick={() => dispatch(clearAuthData())}
        />
      </List>
    </Popover>
  );
}

ProfileMenu.propTypes = {
  setProfileMenu: PropTypes.func,
  profileMenu: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default ProfileMenu;
